import { Pipe, PipeTransform } from '@angular/core';
import { InstanceService } from './instance.service';

export type InstanceLabelKey = 'clientSingular' | 'clientPlural' | 'dmsSingular' | 'dmsPlural';

@Pipe({ name: 'instLabel', pure: true })
export class InstanceLabelPipe implements PipeTransform {
  constructor(private instance: InstanceService) {}

  transform(key: InstanceLabelKey): string {
    return this.instance.labels?.[key] ?? key;
  }
}
